import Tour from "./Tour";

export type { ITourProps } from "./Tour";

export default Tour;
